import { Action } from 'redux';
import { isUpdateAssetListItemsAction } from '../actions/spaces/UpdateAssetListItemsAction';
import { AssetListState } from '../state/AssetListState';

const InitialState: AssetListState = {
  items: [],
};

export function assetListReducer(assetListState = InitialState, action: Action = null): AssetListState {
  if (isUpdateAssetListItemsAction(action)) {
    return { items: action.items };
  }

  return assetListState;
}
